/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiKioskAddTransactionPost } from '../fn/kiosk/api-kiosk-add-transaction-post';
import { ApiKioskAddTransactionPost$Params } from '../fn/kiosk/api-kiosk-add-transaction-post';
import { apiKioskLogoutAccountPost } from '../fn/kiosk/api-kiosk-logout-account-post';
import { ApiKioskLogoutAccountPost$Params } from '../fn/kiosk/api-kiosk-logout-account-post';
import { apiKioskLogoutAlternatePost } from '../fn/kiosk/api-kiosk-logout-alternate-post';
import { ApiKioskLogoutAlternatePost$Params } from '../fn/kiosk/api-kiosk-logout-alternate-post';
import { apiKioskSearchByBarcodePost } from '../fn/kiosk/api-kiosk-search-by-barcode-post';
import { ApiKioskSearchByBarcodePost$Params } from '../fn/kiosk/api-kiosk-search-by-barcode-post';
import { apiKioskSearchByPinPost } from '../fn/kiosk/api-kiosk-search-by-pin-post';
import { ApiKioskSearchByPinPost$Params } from '../fn/kiosk/api-kiosk-search-by-pin-post';
import { KioskAffiliatedUserDto } from '../models/kiosk-affiliated-user-dto';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class KioskService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiKioskSearchByBarcodePost()` */
  static readonly ApiKioskSearchByBarcodePostPath = '/api/kiosk/search-by-barcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKioskSearchByBarcodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskSearchByBarcodePost$Response(params?: ApiKioskSearchByBarcodePost$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskAffiliatedUserDto>> {
    return apiKioskSearchByBarcodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKioskSearchByBarcodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskSearchByBarcodePost(params?: ApiKioskSearchByBarcodePost$Params, context?: HttpContext): Observable<KioskAffiliatedUserDto> {
    return this.apiKioskSearchByBarcodePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskAffiliatedUserDto>): KioskAffiliatedUserDto => r.body)
    );
  }

  /** Path part for operation `apiKioskSearchByPinPost()` */
  static readonly ApiKioskSearchByPinPostPath = '/api/kiosk/search-by-pin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKioskSearchByPinPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskSearchByPinPost$Response(params?: ApiKioskSearchByPinPost$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskAffiliatedUserDto>> {
    return apiKioskSearchByPinPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKioskSearchByPinPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskSearchByPinPost(params?: ApiKioskSearchByPinPost$Params, context?: HttpContext): Observable<KioskAffiliatedUserDto> {
    return this.apiKioskSearchByPinPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskAffiliatedUserDto>): KioskAffiliatedUserDto => r.body)
    );
  }

  /** Path part for operation `apiKioskAddTransactionPost()` */
  static readonly ApiKioskAddTransactionPostPath = '/api/kiosk/add-transaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKioskAddTransactionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskAddTransactionPost$Response(params?: ApiKioskAddTransactionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiKioskAddTransactionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKioskAddTransactionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskAddTransactionPost(params?: ApiKioskAddTransactionPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiKioskAddTransactionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiKioskLogoutAlternatePost()` */
  static readonly ApiKioskLogoutAlternatePostPath = '/api/kiosk/logout-alternate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKioskLogoutAlternatePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKioskLogoutAlternatePost$Response(params?: ApiKioskLogoutAlternatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiKioskLogoutAlternatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKioskLogoutAlternatePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiKioskLogoutAlternatePost(params?: ApiKioskLogoutAlternatePost$Params, context?: HttpContext): Observable<void> {
    return this.apiKioskLogoutAlternatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiKioskLogoutAccountPost()` */
  static readonly ApiKioskLogoutAccountPostPath = '/api/kiosk/logout-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKioskLogoutAccountPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskLogoutAccountPost$Response(params?: ApiKioskLogoutAccountPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiKioskLogoutAccountPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKioskLogoutAccountPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKioskLogoutAccountPost(params?: ApiKioskLogoutAccountPost$Params, context?: HttpContext): Observable<void> {
    return this.apiKioskLogoutAccountPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
